import { Component, Injector, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { AppComponentBase } from '@shared/common/app-component-base';
import { Subscription } from 'rxjs';

@Component({
    selector: 'mazars-deadline-dates',
    templateUrl: './mazars-deadline-dates.component.html',
    styleUrls: ['./mazars-deadline-dates.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: MazarsDeadlineDatesComponent,
        },
    ],
})
export class MazarsDeadlineDatesComponent extends AppComponentBase implements ControlValueAccessor, OnInit, OnDestroy {
    @Input({ required: true }) uid: string;
    @Input() tooltipMessage: string;
    @Input() isDisabled: boolean;
    @Input() submitting: boolean;

    subscriptions: Subscription[] = [];
    form: FormGroup;

    constructor(injector: Injector, private fb: FormBuilder) {
        super(injector);
    }

    get value(): any {
        return this.form.value;
    }

    set value(value: any) {
        this.form.patchValue(value);
    }

    ngOnInit(): void {
        this.createForm();

        this.subscriptions.push(
            this.form.valueChanges.subscribe((value) => {
                this.onChange(value);
                this.onTouched();
            })
        );
    }

    onChange = (_) => {
        // This is intentional
    };

    onTouched = () => {
        // This is intentional
    };

    writeValue(obj: any): void {
        if (obj) {
            this.value = obj;
        } else {
            this.form.reset();
        }

        this.onChange(obj);
        this.onTouched();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    validate(_: FormControl) {
        return this.form.valid ? null : { deadlineDates: { valid: false } };
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }

    isDueDateFirstReminderInvalid(): boolean {
        return (
            this.form.controls.dueDateFirstReminder.touched &&
            this.form.controls.dueDateFirstReminder.value &&
            this.form.controls.dueDateFirstReminder.value < 0
        );
    }

    private createForm(): void {
        this.form = this.fb.group({
            dueDateFirstReminder: [null, [Validators.required, Validators.min(0), Validators.max(300)]],
            dueDateFirstReminderActive: [false],
            dueDateHasExceeded: [false],
        });
    }
}
